import React from "react";
import { Modal as AntdModal } from "antd";

export function Model({ title, open, footer = null, oncancel, width, body = null }) {
  return (
    <>
      <AntdModal
        title={title}
        open={open}
        footer={footer}
        onCancel={oncancel}
        width={width}
      >
        {body}
      </AntdModal>
    </>
  );
}
